import { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserX } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AppointmentContactSettings = () => {
  const [saved, setSaved] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/notifications/appointment-contact`).then(({ data }) => { setSaved(data); setEmail(data.email); }).catch(() => {});
  }, []);
  if (!saved) return null;

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await axios.put(`${API}/notifications/appointment-contact`, { email: email.trim() });
      setSaved(data); setEmail(data.email);
      toast.success("Default appointment contact saved");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg space-y-3" data-testid="appointment-contact-settings">
      <div className="flex items-start gap-2">
        <UserX className="w-5 h-5 text-amber-600 mt-0.5" />
        <div>
          <p className="font-semibold text-amber-900">Default appointment contact</p>
          <p className="text-sm text-amber-800">When an appointment is created (in the app or via the API / phone agent) without a technician, this address gets an email asking to assign one. Also sent when a technician is removed from an appointment.</p>
        </div>
      </div>
      <div className="flex flex-wrap items-end gap-3">
        <div className="flex-1 min-w-[260px]">
          <Label htmlFor="appt-contact-email">Notification email</Label>
          <Input id="appt-contact-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={saved.default} data-testid="appointment-contact-email-input" />
        </div>
        <Button onClick={save} disabled={busy || email.trim() === saved.email || !email.trim()} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="appointment-contact-save-button">
          {busy ? "Saving…" : "Save"}
        </Button>
        {saved.email !== saved.default && (
          <Button variant="ghost" size="sm" onClick={() => setEmail(saved.default)} data-testid="appointment-contact-reset-button">Use default ({saved.default})</Button>
        )}
      </div>
    </div>
  );
};
